<template>
    <el-drawer
        class="train-drawer"
        title="培训计划表格设置"
        :append-to-body="true"
        :visible.sync="visible">
        <el-tag type="success">展示哪些列</el-tag>
        <el-checkbox-group v-model="columns" class="column-group">
            <el-checkbox label="name" disabled>培训名称</el-checkbox>
            <el-checkbox label="specialName">培训专题</el-checkbox>
            <el-checkbox label="typeName">培训类别</el-checkbox>
            <el-checkbox label="formName">考核形式</el-checkbox>
            <el-checkbox label="forLevelName">适用级别</el-checkbox>
            <el-checkbox label="duration">时间</el-checkbox>
            <el-checkbox label="hours">学时</el-checkbox>
            <el-checkbox label="credit">学分</el-checkbox>
            <el-checkbox label="percent">培训进度</el-checkbox>
            <el-checkbox label="creatorName">创建人</el-checkbox>
        </el-checkbox-group>

        <div class="btn-wrap">
            <el-button @click="save" type="success" size="medium">保存</el-button>
        </div>
    </el-drawer>
</template>

<script>
    import {mapGetters} from 'vuex';


    export default {
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                visible: false,
                columns: ['name', 'specialName', 'typeName', 'formName', 'forLevelName', 'duration',
                'hours', 'credit', 'percent', 'creatorName']
            }
        },
        computed: {
            ...mapGetters([
                'userTrainSetting',
            ]),
        },
        mounted() {

        },
        methods: {
            initDrawer() {
                this.$store.commit('initUserTrainSetting')
                if (this.userTrainSetting.columns) {
                    this.columns = [...this.userTrainSetting.columns]
                }
            },

            save() {
                let data = {
                    columns: this.columns
                }
                this.$store.commit('initUserTrainSetting', data)
                this.visible = false

                // 改变了elTable后得手动重排，不然elTable高度会计算错误
                this.$nextTick(() => {
                    let elTable = this.$parent.$refs.trainTable.$refs.elTable
                    elTable && elTable.doLayout()
                })
            }
        },
        watch: {
            visible(val) {
                // 打开
                if (val) {
                    this.initDrawer();
                    // 关闭
                } else {
                    this.$emit('update:show', false)
                }
            },
            show() {
                this.visible = this.show;
            }
        },
    }
</script>

<style lang="scss">
    .train-drawer {
        .el-drawer {
            width: 360px !important;
        }
        .el-drawer__body {
            padding: 0 20px 20px 20px;
        }
        .el-drawer__header {
            color: #333;
            font-weight: 600;
        }
        .el-tag {
            margin-bottom: 10px;
        }
        .column-group {
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            label {
                width: 100%;
                margin-right: 0;
                margin-bottom: 10px;
            }
        }
        .btn-wrap {
            padding-top: 10px;
            text-align: center;
            button {
                letter-spacing: 2px;
            }
        }
    }
</style>
